/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
   document.addEventListener('DOMContentLoaded', () => {
    const triggerFakeBtn = () => {
        if (document.querySelector('.myClick')) {
            const fakeBttns = document.querySelectorAll('.myClick');
             console.log('нажалиииии1')
            fakeBttns.forEach( bttn => {
                bttn.addEventListener('click', (e) => {
                  console.log('нажалиииии2')
                  
                    
                    
                })
            })
        }
    }

    triggerFakeBtn();
})


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
